import { Provider } from "react-redux";
import { QueryClientProvider } from "@tanstack/react-query";
// import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { FilterProvider } from "features/Filter";
import { TagsProvider } from "features/Tags";
import { queryClient } from "shared/api/queryClient";
import { store } from "shared/lib/redux";
import { LocalizationProvider } from "shared/localization/localization";
import { localization } from "shared/localization/localization";
// import { AppDOM } from "shared/utils/app.utils";

export const RootProviders: RFC = ({ children }) => {
  return (
    <Provider store={store}>
      <QueryClientProvider client={queryClient}>
        <LocalizationProvider i18n={localization}>
          <FilterProvider>
            <TagsProvider>
              {children}
              {/* {__DEV__ && (
                <ReactQueryDevtools
                  initialIsOpen={false}
                  shadowDOMTarget={AppDOM.shadowRootNode}
                  buttonPosition="bottom-left"
                />
              )} */}
            </TagsProvider>
          </FilterProvider>
        </LocalizationProvider>
      </QueryClientProvider>
    </Provider>
  );
};
